import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getConditionsFilterConfig } from '../filters/condition';
import { BuilderSections } from '../../util/builder';
import { MediaPayload } from '../configHelper';

const nationSizes: string[] = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'OS'];

const isGhostImage = (mediaItem: MediaPayload) => {
  const split = mediaItem?.url?.split('.') || [];
  const fileNamePortion = split[split.length - 2];
  return !!fileNamePortion?.match(/[-_]G(?:\d+|-\d+)?$/);
};

const getMediaForProduct = (media?: MediaPayload[]) => {
  if (!media) return [];
  const matches = media.filter(isGhostImage);
  const nonMatches = media.filter((mediaItem) => !isGhostImage(mediaItem));

  return [...matches, ...nonMatches];
};

const getMediaForVariant = (media?: MediaPayload[]) => {
  if (!media) return [];
  const ghostImages = media.filter(isGhostImage);
  return [...ghostImages];
};

export const nationShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: nationSizes,
    }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'a6852fe6e3df49dfa624a925a6d49b1d',
      [BuilderSections.TopbarContent]: '2e51c9061f524438965c3ebd8f4c648b',
      [BuilderSections.ListingCardDetails]: '8b46dcbe25cb4a6a9f4bfcce9e15f8d3',
      [BuilderSections.ListingPageTitleAndVariantDetailsContent]:
        '1420c93b664d47399d97c117c14f1cd6',
    },
  },
  getMediaForProduct,
  getMediaForVariant,
  shouldDisableRemovingFeaturedStockPhoto: true,
};
